<template lang="pug">
  .b2b-filter-button-documentacion
    ods-tag(
      closable='',
      type='secondary',
      @close='closeTagFilter')
      span.b2b-filter-button__value {{ $t(filter.value) }} :
      span.b2b-filter-button__query {{ getLabel }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filter-button-documentacion',
  mixins: [Utils],
  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      filterListAfterRemove: []
    }
  },

  computed: {
    ...mapGetters([
      'queryDocumentation',
      'listSelectedFiltersDocumentation',
      'urlIn'
    ]),

    getLabel () {
      if (this.filter.col.includes('Date')) {
        return this.$d(this.filter.labelText[0]) + '-' + this.$d(this.filter.labelText[1])
      } else {
        return this.filter.labelText
      }
    }
  },

  methods: {
    ...mapActions([
      'getDocumentation',
      'queryDocumentationState',
      'listSelectedFiltersDocumentationState'
    ]),

    async closeTagFilter () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete')
      })

      this.filter.selected = false // eslint-disable-line
      this.filterListAfterRemove = this.listSelectedFiltersDocumentation.filter(
        item => item.prop !== this.filter.prop
      )

      switch (this.filter.prop) {
        case 'projectId':
          this.queryDocumentation.projectId = ''
          break
        case 'name':
          this.queryDocumentation.name = ''
          break
        case 'idCategory':
          this.queryDocumentation.categoryId = ''
          break
        case 'idLanguage':
          this.queryDocumentation.languageId = ''
          break
        default:
          break
      }

      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryDocumentation.urlName = this.urlIn
        } else {
          this.queryDocumentation.urlName = null
        }
        await this.queryDocumentationState(this.queryDocumentation)
        dataQuery.query = this.queryDocumentation
        await this.getDocumentation(dataQuery)
        console.log('getDocumentation 1')

        this.$emit('closeTag', { filter: this.filter, listAfterRemove: this.filterListAfterRemove })
      } catch (error) {
        console.log('closeTagFilter FILTER CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
